export const PRINT_DPI = 96;
export const PRINT_PIXEL_COEFFICIENT = 25.4;

export const pixelsToMms = (pixels: number) => Math.round((pixels / PRINT_DPI) * PRINT_PIXEL_COEFFICIENT);
